import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { faFileExcel, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SimuladorLiquidoService } from '../../../services/previdencia/simulador-liquido.service';
import { SimulacaoPlanoIVPDFComponent } from 'src/app/shared/pdf/simulacao-plano-iv-pdf/simulacao-plano-iv-pdf.component';
@Component({ selector: 'app-simulacao-plano-iv', templateUrl: './simulacao-plano-iv.component.html', styleUrls: ['./simulacao-plano-iv.component.css'] })
export class SimulacaoPlanoIVComponent {
  faPdf = faFilePdf;
  faExcel = faFileExcel;
  @Input() valor: any = null;
  @Output() errorToEmit = new EventEmitter<any>();
  //Variaveis personalizacao simulacao
  valorMinimoIdade: number = 45;
  valorMaximoIdade: number = 110;
  //Listas
  meses: string[] = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11'];
  percentual: string[] = ['1', '2', '3', '4'];
  taxa: string[] = ['4', '5', '6'];
  tipoRecebimento: string[] = ['Percentual ao mês', 'Prazo determinado'];
  //variaveis no sistema
  dataAtual: string = new Date().toLocaleDateString("pt-BR");
  loading: boolean = false;
  loadingCsv: boolean = false;
  loadingPdf: boolean = false;
  simulation: any = null;
  page: number = 1;
  items: number = 10;
  totalItems: number = 0;
  itemsPage: any[] = [];
  formGroup: FormGroup = new FormGroup({
    anoAposentar: new FormControl(45, [Validators.required]),
    mesAposentar: new FormControl(null, [Validators.required]),
    taxaJuros: new FormControl(6),
    percentualSobreSRC: new FormControl(2, [Validators.required]),
    aporte: new FormControl(null, [Validators.required]),
    prazoRecebimento: new FormControl(null, [Validators.required]),
    percentualRecebimento: new FormControl(1, [Validators.required]),
    tipoRecebimento: new FormControl('Percentual ao mês', [Validators.required])
  });
  constructor(private simuladorLiquidoService: SimuladorLiquidoService, private modalService: NgbModal) {
    this.consultar();
  }
  consultar() {
    this.loading = true;
    this.simuladorLiquidoService.getSimuladorPlanoIV(this.formGroup.value).subscribe(
      (res: any) => {
        this.simulation = res;
        this.formGroup.patchValue(res.filtro); //todo
        this.formGroup.value.tipoRecebimento = 'Percentual ao mês'; //todo
        this.totalItems = res.meses.length;
        let startIndex = (this.page - 1) * this.items;
        this.itemsPage = this.simulation.meses.slice(startIndex, (startIndex + this.items));
        this.loading = false;
      }
    );
  }
  printPdf() {
    this.loadingPdf = true;
    const modalRef = this.modalService.open(SimulacaoPlanoIVPDFComponent, { windowClass: 'custom-modal-size-imprimir', size: 'lg', centered: true });
    modalRef.componentInstance.simulacao = this.simulation;
    modalRef.result.then((result) => {
      if (result) {
        this.loadingPdf = false;
      }
    }).catch((error) => {
      this.loadingPdf = false;
    });
  }
  printCsv() {
    this.loadingCsv = true;
    this.simuladorLiquidoService.getSimuladorPlanoIVCSV(this.formGroup.value).subscribe(
      (data: Blob) => {
        const a = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        a.download = "Simulacao de Contribuicoes-Beneficio.csv";
        a.href = URL.createObjectURL(data);
        a.target = '_blank';
        a.click();
        document.body.removeChild(a);
        this.loadingCsv = false;
      }
    );
  }
  onChangeQuantidadeItens(quantidade: number) {
    this.items = quantidade;
    this.page = 1;
    let startIndex = (this.page - 1) * this.items;
    this.itemsPage = this.simulation.meses.slice(startIndex, (startIndex + this.items));
  }
  onChangePagination(page: number) {
    this.page = page;
    let startIndex = (this.page - 1) * this.items;
    this.itemsPage = this.simulation.meses.slice(startIndex, (startIndex + this.items));
  }
}
